<div class="px-4">
  @if (isNativeApp) {
    <div
      class="d-flex gap-2 flex-wrap justify-content-center align-items-center bg-info-subtle p-3"
    >
      <div>
        <ul>
          <li>
            Open the website in a browser
            <span class="ms-3" (click)="copyWebsiteLink()"
              ><i class="fa-solid fa-copy"></i
            ></span>
          </li>
          <li>Open Subscriptions to manage your subscriptions</li>
        </ul>
        <!-- <div>Follow the steps to manage your subscription</div> -->
      </div>
      <div>
        <button
          class="btn btn-success btn-md text-center"
          (click)="sendManageSubscriptionMail()"
        >
          Send Mail
        </button>
      </div>
    </div>
  } @else {
    @if (pageLoaded) {
      <div>
        <!-- @if (subscriptions?.length && !currentSubscription) {
        <div>
          <div class="alert alert-warning my-2 text-center">
            Subscription Expired
          </div>
        </div>
      } -->
        @if (showPlans === true) {
          <!-- First Time subscriber header -->
          @if (!currentSubscription) {
            @if (!exBeta && firstTimeSubscriber && subscriptions.length === 0) {
              <div class="text-center mb-3 pt-4">
                <h5>Step 6: Select Plan</h5>
              </div>
            }
            <!-- EXPIRED  SUBSCRIBERS -->
            @if (expiredSubscriptions?.length && subscriptions.length > 0) {
              <div class="text-center mb-3">
                <h5>Subscribe</h5>
                <div class="mb-3">
                  To reactivate Guard Tracker access, please subscribe to a
                  plan.
                </div>
                <div class="mb-3">
                  Change plans later or cancel at any time.
                </div>
              </div>
            }
            <!-- Ex Beta user's header -->
            @if (exBeta && subscriptions.length === 0) {
              <div class="text-center mb-3">
                <div class="mb-3">
                  To reactivate Guard Tracker access, please subscribe to a
                  plan.
                </div>
                <div class="mb-3">
                  Change plans later or cancel at any time.
                </div>
              </div>
            }
          }
          <!-- showing plan list here-->
          <div class="text-center my-3 px-2">
            {{ pricingDescription }}
          </div>
          <div
            id="pricing-container"
            class="d-flex flex-wrap justify-content-center flex-row gy-3 mb-3"
          >
            @for (plan of appPlans; track plan) {
              <div
                class="pricing-plan shadow"
                [ngClass]="
                  plan?.recommended
                    ? 'border border-primary-subtle border-4'
                    : ''
                "
              >
                <div class="h-100 d-flex flex-column">
                  <div>
                    <h4 class="plan-name">{{ plan.name }}</h4>
                    <p class="card-text description mb-1">
                      Includes {{ plan?.allowed_users }} Users
                    </p>
                    <hr />
                    @if (plan?.trial_days && isTrialApplicable) {
                      <div class="mt-1">
                        <p class="card-text">
                          <span class="price">
                            {{ regionCurrencySymbol }}0</span
                          >
                          for the first {{ plan.trial_days }} days
                        </p>
                        <p class="card-text mb-0">then</p>
                      </div>
                    }
                    <div
                      [ngClass]="
                        !plan?.trial_days || !isTrialApplicable ? 'pt-3' : ''
                      "
                      class="mt-auto"
                    >
                      <p class="mb-0">
                        <span class="price mt-2">
                          {{ regionCurrencySymbol
                          }}{{ plan.final_amount }}</span
                        >
                        per month
                      </p>
                      @if (plan?.plan_type == 1) {
                        <p class="mt-1 mb-3">
                          <span class="fw-bold">
                            {{ regionCurrencySymbol
                            }}{{ getRoundOffValue(plan?.user_cost, false) }}
                          </span>
                          per additional user
                        </p>
                      }
                      @if (plan?.plan_type == 2) {
                        <!-- transaction price payment plan-->
                        <div class="small mb-0">
                          {{ plan?.allowed_transactions }} transactions included
                        </div>
                        <div class="small">
                          {{ getRoundOffValue(plan?.transaction_price) }}c per
                          transaction thereafter
                        </div>
                      }
                    </div>
                    @if (plan?.recommended) {
                      <div class="text-center small">
                        Save
                        <span class="fw-bold">
                          {{ regionCurrencySymbol }}{{ plan?.amtSavable }}
                        </span>
                        per month switching to this plan
                      </div>
                    }
                  </div>
                  <div class="card-footer mt-auto">
                    <button
                      class="btn btn-primary btn-select-plan btn-lg w-100"
                      (click)="onPlanClick(plan)"
                    >
                      Select
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
          @if (currentSubscription && showPlans) {
            <div class="col m-auto w-50">
              <button
                class="btn btn-dark w-100 btn-lg"
                (click)="showPlans = !showPlans; showApplyCouponForm = false"
              >
                Cancel
              </button>
            </div>
          }
        }
        @if (showPaymentForm === true) {
          <div>
            <gtapp-payment-form
              [selectedPlan]="selectedPlan"
              [currentSubscription]="currentSubscription"
              [totalPermanentUsers]="totalPermanentUsers"
              (emitData)="cancelPaymentForm()"
            >
            </gtapp-payment-form>
          </div>
        }
        @if (showApplyCouponForm === true) {
          <div class="p-2 col-lg-7 col-xl-5 m-auto">
            <div class="mb-2">
              <h5 class="plan-name mb-4">
                {{ queuedPlanData?.plan?.name }}
              </h5>
              <div class="mb-0 mt-1">
                <span>
                  {{ regionCurrencySymbol
                  }}{{ queuedPlanData?.plan?.final_amount }}</span
                >
                per month
              </div>
              @if (queuedPlanData?.plan?.plan_type == 1) {
                <!-- user price payment plan-->
                <div class="mt-2">
                  {{ regionCurrencySymbol
                  }}{{
                    queuedPlanData?.plan?.user_cost | misc: "convertIntoDollar"
                  }}
                  per additional user
                </div>
                @if (
                  showSqForm && !paymentCards?.length && getTotalAmount() > 0
                ) {
                  <input
                    class="form-control mt-3 lh-lg mb-2"
                    type="text"
                    [(ngModel)]="cardHolderName"
                    id="name"
                    placeholder="Name"
                  />
                  <div id="card-container"></div>
                  <!-- <button
                      type="button"
                      class="btn btn-primary btn-lg w-100 mb-2"
                      [disabled]="!cardHolderName"
                      (click)="tokenizeAddNewCard()"
                      >
                      Add Card
                    </button> -->
                  <div>
                    Please note that we do not save your credit card details.
                    These details are saved securely via our payment partner
                    @if (!isPWAApp) {
                      <a
                        href="https://squareup.com/au/en/legal/general/ua"
                        target="_"
                        >SquareUp</a
                      >
                    }
                    @if (isPWAApp) {
                      <span>SquareUp</span>
                    }
                    .
                  </div>
                }
                <div class="mt-5 mb-2">
                  <!-- Display Extra Users and Pricing -->
                  <div>
                    <div class="mb-3">
                      <!-- Headers -->
                      <div class="row row-cols-4">
                        <div class="col-6 px-1 fw-bold"></div>
                        <div class="col-1 px-1 fw-bold text-center">Qty</div>
                        <div class="col-3 px-2 fw-bold text-end">
                          Unit Price
                        </div>
                        <div class="col-2 px-1 fw-bold text-end">Total</div>
                      </div>
                      <!-- Base Plan -->
                      <div class="row row-cols-4 my-2">
                        <div class="col-6">
                          {{ queuedPlanData?.plan?.name }} ({{
                            queuedPlanData?.plan?.allowed_users
                          }}
                          Users)
                        </div>
                        <div class="col-1 px-1 text-center">1</div>
                        <div class="col-3 px-1 text-end">
                          {{ regionCurrencySymbol
                          }}{{
                            (queuedPlanData?.plan?.final_amount).toFixed(2)
                          }}
                        </div>
                        <div class="col-2 px-1 text-end">
                          {{ regionCurrencySymbol
                          }}{{
                            (queuedPlanData?.plan?.final_amount).toFixed(2)
                          }}
                        </div>
                      </div>
                      <!-- Additional Guards -->
                      @if (
                        allottedSlots > queuedPlanData?.plan?.allowed_users
                      ) {
                        <div class="row row-cols-4 mb-2">
                          <div class="col-6">Additional User(s)</div>
                          <div class="col-1 px-1 text-center">
                            {{
                              allottedSlots -
                                queuedPlanData?.plan?.allowed_users
                            }}
                          </div>
                          <div class="col-3 px-1 text-end">
                            {{ regionCurrencySymbol
                            }}{{ (queuedPlanData?.plan?.user_cost).toFixed(2) }}
                          </div>
                          <div class="col-2 px-1 text-end">
                            {{ regionCurrencySymbol
                            }}{{ getExtraUserCost().toFixed(2) }}
                          </div>
                        </div>
                      }
                      <!-- reserved user billing info-->
                      @if (reservedUserBillingInfo) {
                        <div class="row row-cols-4 mb-3">
                          <div
                            class="col-6 fw-semibold"
                            role="button"
                            (click)="openReserveUserBillingTemplate()"
                          >
                            Casual User Fees
                            <span
                              ><i class="fa-solid fa-circle-info fs-6"></i
                            ></span>
                          </div>
                          <div class="col-1 px-1 text-center">
                            {{ reservedUserBillingInfo?.total_count }}
                          </div>
                          <div class="col-3 px-1 text-end">
                            {{ regionCurrencySymbol
                            }}{{
                              reservedUserBillingInfo?.per_day_per_guard_price?.toFixed(
                                2
                              )
                            }}
                          </div>
                          <div class="col-2 px-1 text-end">
                            {{ regionCurrencySymbol
                            }}{{
                              (reservedUserBillingInfo?.total_amount).toFixed(2)
                            }}
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
            @if (isCouponApplied) {
              <!-- Display the applied coupon with a remove option -->
              <div class="d-flex mb-3 align-items-center">
                <span
                  >Coupon
                  <span class="fw-semibold">{{ couponCode }}</span> Applied
                </span>
                <button
                  (click)="removeAppliedCoupon()"
                  class="btn btn-sm btn-outline-danger ms-2"
                >
                  Remove
                </button>
              </div>
            }
            @if (showCouponInput && !isCouponApplied) {
              <div class="d-flex">
                <input
                  class="form-control flex-grow-1 me-2"
                  type="text"
                  [(ngModel)]="couponCode"
                  id="couponCode"
                  placeholder="Coupon code"
                  (input)="forceUppercaseConditionally($event)"
                />
                <button
                  class="btn btn-primary btn-lg"
                  (click)="onApplyCouponCode()"
                  [disabled]="!couponCode"
                >
                  Apply
                </button>
              </div>
              @if (errorCouponCode === true) {
                <div class="text-danger mb-3">Invalid coupon</div>
              }
            }
            @if (!showCouponInput && !isSubscriberLocked) {
              <div class="text-end">
                <button
                  (click)="showCouponInput = !showCouponInput"
                  class="btn btn-primary fw-semibold btn mb-2"
                >
                  Apply Coupon
                </button>
              </div>
            }
            @if (queuedPlanData?.plan?.plan_type == 1) {
              <div class="mt-2 text-end">
                <div class="row row-cols-2">
                  @if (dataAfterCouponApplied?.applicableDiscount) {
                    <div class="col">Discount</div>
                    <div>
                      - {{ regionCurrencySymbol
                      }}{{
                        dataAfterCouponApplied?.applicableDiscount?.toFixed(2)
                      }}
                    </div>
                  }
                  <div class="col">GST</div>
                  <div>{{ regionCurrencySymbol }}{{ getGSTAmount() }}</div>
                  <div class="col fw-bold">Total with GST</div>
                  <div class="fw-bold fs-5">
                    {{ regionCurrencySymbol }}{{ getTotalAmount().toFixed(2) }}
                  </div>
                </div>
              </div>
            }
            <div class="small-font text-end me-3 mt-2 mb-2">
              Change plans later or cancel at any time
            </div>
            <div class="mt-2 mb-2">
              <div class="alert fw-semibold text-primary text-end">
                This amount will be charged on
                {{ getBillingDate(currentSubscription) | date: "d MMMM y" }}
              </div>
            </div>
            <div class="row row-cols-2 gy-2">
              <div class="col">
                <button
                  class="btn btn-dark w-100 btn-lg"
                  (click)="
                    queuedPlanData = null;
                    queuedPlanDataCopy = null;
                    showApplyCouponForm = false;
                    isCouponApplied = false;
                    couponCode = null;
                    dataAfterCouponApplied = null;
                    showCouponInput = false
                  "
                >
                  Cancel
                </button>
              </div>
              <div class="col">
                <button
                  class="btn btn-primary w-100 btn-lg"
                  [disabled]="
                    !paymentFormValid &&
                    getTotalAmount() > 0 &&
                    !paymentCards?.length
                  "
                  (click)="queueSubscription()"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        }
        @if (!showPlans && !showPaymentForm && !showApplyCouponForm) {
          @if (currentSubscription && !showApplyCouponForm && !addUser) {
            <div class="mt-4">
              <div class="row row-cols-lg-2">
                <div class="col-12 col-lg-10">
                  <div
                    class="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-xl-2"
                  >
                    <div class="col-12 col-lg-5 col-xl-5">
                      <dl>
                        <dt>Your Plan Details</dt>
                        <dd>
                          {{ currentSubscription?.plan?.name }}
                          <br />
                          <span>
                            {{ regionCurrencySymbol
                            }}{{
                              currentSubscription?.plan?.final_amount
                            }}</span
                          ><span> per month</span>
                          @if (currentSubscription?.plan?.plan_type == 1) {
                            <!-- user price payment plan-->
                            <br />
                            <span>
                              {{ regionCurrencySymbol
                              }}{{
                                currentSubscription?.plan?.user_cost
                                  | misc: "convertIntoDollar"
                              }}
                              per additional user per month</span
                            >
                            <br />
                          }
                        </dd>
                      </dl>
                      @if (currentSubscription?.plan?.plan_type == 1) {
                        <div class="d-flex align-items-start gap-4">
                          <dl>
                            <dt>Permanent Users</dt>
                            <div class="d-flex align-items-center gap-3">
                              <dd>
                                {{ currentSubscription?.allotted_slots }}
                                @if (
                                  currentSubscription?.allotted_slots >
                                  currentSubscription?.plan?.allowed_users
                                ) {
                                  [{{
                                    currentSubscription?.plan?.allowed_users
                                  }}
                                  @if (
                                    currentSubscription?.allotted_slots -
                                    currentSubscription?.plan?.allowed_users
                                  ) {
                                    +
                                    {{
                                      currentSubscription?.allotted_slots -
                                        currentSubscription?.plan?.allowed_users
                                    }}
                                  }
                                  ]
                                }
                              </dd>
                              <button
                                class="btn btn-sm btn-outline-secondary"
                                routerLink="/users"
                              >
                                Manage Users
                              </button>
                            </div>
                          </dl>
                        </div>
                      }
                    </div>
                    <div class="col-12 col-lg-7 col-xl-7">
                      @if (!queuedSelectedPlanData?.plan?.id) {
                        <div>
                          <dl>
                            <dt>
                              {{
                                currentSubscription?.recurring_plan
                                  ? "Renewal Details"
                                  : "Subscription Ends"
                              }}
                            </dt>
                            <dd
                              [ngClass]="
                                currentSubscription?.recurring_plan
                                  ? ''
                                  : 'text-danger'
                              "
                            >
                              @if (currentSubscription?.recurring_plan) {
                                <ng-container>
                                  @if (
                                    (currentSubscription
                                      | misc
                                        : "getFinalPaymentAmount"
                                        : totalPermanentUsers
                                        : reservedUserBillingInfo) == 0
                                  ) {
                                    @if (
                                      currentSubscription?.app_coupon
                                        ?.coupon_end_date &&
                                      currentSubscription?.app_coupon
                                        ?.coupon_usage_left > 0
                                    ) {
                                      <!-- coupon can be used multiple times-->
                                      Your Plan is valid till
                                      {{
                                        getCouponEndDate(
                                          currentSubscription?.app_coupon
                                            ?.coupon_end_date
                                        ) | date: "d MMM yyy"
                                      }}
                                    } @else if (
                                      !currentSubscription?.app_coupon
                                        ?.coupon_end_date
                                    ) {
                                      Free Subscription
                                    }
                                  } @else {
                                    <span class="fw-bold">
                                      {{ regionCurrencySymbol
                                      }}{{
                                        (
                                          currentSubscription
                                          | misc
                                            : "getFinalPaymentAmount"
                                            : totalPermanentUsers
                                            : reservedUserBillingInfo
                                        ).toFixed(2)
                                      }}
                                    </span>
                                    is due on
                                    {{
                                      getBillingDate(currentSubscription)
                                        | date: "d MMM yyy"
                                    }}
                                  }
                                </ng-container>
                                @if (
                                  (currentSubscription
                                    | misc
                                      : "getFinalPaymentAmount"
                                      : totalPermanentUsers
                                      : reservedUserBillingInfo) > 0
                                ) {
                                  <ng-template
                                    *ngTemplateOutlet="
                                      pricebreakdownTemplate;
                                      context: {
                                        subscriptionPlan: currentSubscription,
                                        allottedSlots: totalPermanentUsers,
                                      }
                                    "
                                  ></ng-template>
                                }
                              } @else {
                                {{
                                  getBillingDate(currentSubscription)
                                    | date: "d MMM yyy"
                                }}
                              }
                            </dd>
                          </dl>
                        </div>
                      }
                      @if (queuedSelectedPlanData?.plan?.id) {
                        <div>
                          @if (paymentCards?.length) {
                            <dl>
                              <dt>Your plan will change on</dt>
                              <dd class="mb-2">
                                <span class="fw-bold">
                                  {{
                                    getBillingDate(currentSubscription)
                                      | date: "d MMM yyy"
                                  }}</span
                                >
                                <br />
                              </dd>
                              <dt>Plan Details</dt>
                              <dd>
                                {{ queuedSelectedPlanData?.plan?.name }}
                                <br />
                                <span class="fw-bold">
                                  {{ regionCurrencySymbol
                                  }}{{
                                    queuedSelectedPlanData?.app_coupon
                                      ?.payable_amount
                                      ? queuedSelectedPlanData?.app_coupon
                                          ?.payable_amount
                                      : queuedSelectedPlanData?.plan
                                          ?.final_amount
                                  }}</span
                                ><span class="small"> /month</span>
                                @if (
                                  queuedSelectedPlanData?.plan?.plan_type == 1
                                ) {
                                  <!-- user price payment plan-->
                                  <br />
                                  <span class="small">
                                    {{
                                      queuedSelectedPlanData?.plan
                                        ?.allowed_users
                                    }}
                                    users included</span
                                  >
                                  <br />
                                  <span class="small">
                                    {{ regionCurrencySymbol }}
                                    {{
                                      queuedSelectedPlanData?.plan?.user_cost
                                        | misc: "convertIntoDollar"
                                    }}
                                    per additional user per month</span
                                  >
                                }
                              </dd>
                            </dl>
                            @if (
                              queuedSelectedPlanData?.plan?.plan_type == 1 &&
                              (queuedSelectedPlanData?.app_coupon
                                ?.payable_amount
                                ? queuedSelectedPlanData?.app_coupon
                                    ?.payable_amount
                                : queuedSelectedPlanData?.plan?.final_amount) >
                                0
                            ) {
                              <dl>
                                <span class="fw-bold">
                                  {{ regionCurrencySymbol
                                  }}{{
                                    (
                                      (queuedSelectedPlanData?.app_coupon
                                        ?.payable_amount
                                        ? queuedSelectedPlanData?.app_coupon
                                            ?.payable_amount
                                        : queuedSelectedPlanData?.plan
                                            ?.final_amount) +
                                      (totalPermanentUsers >
                                      queuedSelectedPlanData?.plan
                                        ?.allowed_users
                                        ? (totalPermanentUsers -
                                            queuedSelectedPlanData?.plan
                                              ?.allowed_users) *
                                          queuedSelectedPlanData?.plan
                                            ?.user_cost
                                        : 0)
                                    ).toFixed(2)
                                  }}</span
                                >
                                is due on
                                {{
                                  getBillingDate(currentSubscription)
                                    | date: "d MMM yyy"
                                }}
                                <ng-template
                                  *ngTemplateOutlet="
                                    pricebreakdownTemplate;
                                    context: {
                                      subscriptionPlan: queuedSelectedPlanData,
                                      allottedSlots: totalPermanentUsers,
                                    }
                                  "
                                ></ng-template>
                              </dl>
                            }
                          } @else {
                            <dt>Subscription Ends</dt>
                            <dd class="text-danger">
                              {{
                                getCouponEndDate(
                                  queuedSelectedPlanData?.app_coupon
                                    ?.coupon_end_date
                                ) | date: "d MMM yyy"
                              }}
                            </dd>
                          }
                          <br />
                          @if (queuedSubscriptions?.length) {
                            <button
                              class="btn btn-dark btn-lg"
                              (click)="deleteQueuedPlan(queuedSelectedPlanData)"
                            >
                              Cancel Plan Change
                            </button>
                          }
                        </div>
                      }
                      @if (
                        paymentCards?.length == 0 &&
                        currentSubscription?.recurring_plan
                      ) {
                        <div class="text-danger alert border">
                          No credit card has been saved, please add one
                          <span class="fw-semibold">
                            @if (
                              (currentSubscription
                                | misc
                                  : "getFinalPaymentAmount"
                                  : totalPermanentUsers
                                  : reservedUserBillingInfo) > 0
                            ) {
                              <ng-container>
                                before
                                {{
                                  getBillingDate(currentSubscription)
                                    | date: "d MMM yyy"
                                }}
                              </ng-container>
                            } @else if (
                              currentSubscription?.app_coupon
                                ?.coupon_end_date &&
                              currentSubscription?.app_coupon
                                ?.coupon_usage_left > 0
                            ) {
                              <ng-container>
                                before
                                {{
                                  getCouponEndDate(
                                    currentSubscription?.app_coupon
                                      ?.coupon_end_date
                                  ) | date: "d MMM yyy"
                                }}
                              </ng-container>
                            }
                          </span>
                          to ensure your service is not disrupted
                        </div>
                      }
                    </div>
                  </div>
                </div>
                @if (
                  !queuedSubscriptions?.length &&
                  currentSubscription?.is_active &&
                  !isSubscriberLocked
                ) {
                  <div class="col-lg-2 ps-2">
                    <div class="row row-cols-1 gy-2">
                      @if (
                        !currentSubscription?.recurring_plan &&
                        paymentCards?.length
                      ) {
                        <div class="col">
                          <button
                            (click)="
                              changeSubscriptionRecursion(currentSubscription)
                            "
                            class="btn btn-lg w-100 btn-success"
                          >
                            Auto Renew
                          </button>
                        </div>
                      }
                      @if (
                        currentSubscription?.recurring_plan &&
                        paymentCards?.length
                      ) {
                        <div class="col">
                          <button
                            class="btn btn-dark w-100 btn-lg"
                            (click)="
                              changeSubscriptionRecursion(currentSubscription)
                            "
                          >
                            Cancel Subscription
                          </button>
                        </div>
                      }
                      <div class="col">
                        <button
                          class="btn btn-primary w-100 btn-lg"
                          (click)="
                            showPlans = !showPlans; showApplyCouponForm = false
                          "
                        >
                          Change Plan
                        </button>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          @if (subscriptions?.length && !showPlans && !addUser) {
            <div class="mt-2">
              <ul class="nav nav-tabs border-0">
                <li class="nav-item" (click)="changeTab(tabNames.tab1)">
                  <a
                    class="nav-link"
                    [ngClass]="selectedTab === tabNames.tab1 ? 'active' : ''"
                    >{{ tabNames.tab1 }}</a
                  >
                </li>
                @if (subscriptionInvoices?.length) {
                  <li class="nav-item" (click)="changeTab(tabNames.tab2)">
                    <a
                      class="nav-link"
                      [ngClass]="selectedTab === tabNames.tab2 ? 'active' : ''"
                      >{{ tabNames.tab2 }}</a
                    >
                  </li>
                }
              </ul>
              <div class="tab-content mt-2">
                <!-- Tab Pane for Tab 1 -->
                <div
                  class="tab-pane"
                  [ngClass]="selectedTab === tabNames.tab1 ? 'active' : ''"
                >
                  <gtapp-saved-cards
                    (selectCard)="changeCardStatus($event)"
                    [savedCards]="paymentCards"
                    [extraParams]="{
                      cardDeleteSubscriptionEndDate:
                        cardDeleteSubscriptionEndDate,
                    }"
                    (getSavedCards)="getSavedCards(true)"
                  >
                  </gtapp-saved-cards>
                </div>
                <!-- Tab Pane for Tab 2 -->
                <div
                  class="tab-pane"
                  [ngClass]="selectedTab === tabNames.tab2 ? 'active' : ''"
                >
                  <gtapp-card-list
                    [mobileCardUIData]="subscriptionInvoices"
                    [mobileCardDetails]="invoiceDetails"
                    [mobileActionIcons]="invoiceIcons"
                    (actionClick)="downloadInvoice($event)"
                    [otherParams]="{
                      paginationData: true,
                      removeCardPointer: true,
                    }"
                  ></gtapp-card-list>
                </div>
              </div>
            </div>
          }
        }
        @if (
          !showPaymentForm &&
          !showApplyCouponForm &&
          !addUser &&
          (!currentSubscription || !showPlans)
        ) {
          <div class="text-end mb-5">
            <button
              class="btn text-secondary btn-lg"
              (click)="deleteSubscriberTemplate(deleteAccountTemp)"
            >
              Close Account
            </button>
          </div>
        }

        <!-- @if (
          (!showPlans &&
            showPaymentForm === false &&
            subscriptions?.length > 0) ||
          (currentSubscription &&
            currentSubscription?.recurring_plan === false &&
            !showPlans &&
            addUser === false)
        ) {
          
        } -->
      </div>
    }
  }
  <ng-template #deleteAccountTemp let-delRef="dialogRef">
    <div class="dialog-box card">
      <div class="card-header">
        CLOSE ACCOUNT

        <span class="float-end" (click)="delRef.close()">
          <i class="fa-solid fa-xmark"></i>
        </span>
      </div>
      <div>
        <div class="alert alert-danger fw-bold text-center">
          <p>THIS ACTION CANNOT BE UNDONE!</p>
          <p>
            BY CLOSING YOUR ACCOUNT YOU AGREE TO HAVE ALL YOUR DATA DELETED.
          </p>
        </div>

        @if (deleteAccStep === 1) {
          <div class="text-center">
            To confirm deletion, type {{ randomNumber }} in the field:
          </div>
          <div class="mt-2">
            <input
              class="form-control"
              tabindex="1"
              autofocus
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              placeholder="{{ randomNumber }}"
              (input)="checkValidation($event)"
            />
          </div>
        }
        @if (deleteAccStep === 2) {
          <div class="my-4 form-floating">
            <select
              class="form-select"
              (change)="selectDeleteReason($event)"
              placeholder="Reason for account closure"
            >
              <option disabled value="" selected hidden>Select a Reason</option>
              @for (reason of feedbackOptions; track reason) {
                <option [value]="reason.option">
                  {{ reason.option }}
                </option>
              }
            </select>
            <label for="">Reason for account closure</label>
          </div>
          @if (showReasonText) {
            <div>
              <textarea
                class="form-control"
                autofocus
                rows="4"
                placeholder="Your valuable feedback"
                autocomplete="off"
                [(ngModel)]="cancelReason"
                style="resize: none"
              ></textarea>
            </div>
          }
        }

        <div class="row row-cols-2 mt-2">
          <div
            class="col"
            (click)="
              delRef.close(); cancelReason = null; showReasonText = false
            "
          >
            <button
              tabindex="-1"
              id="cancelBtn"
              class="btn btn-dark btn-lg w-100"
            >
              Cancel
            </button>
          </div>
          <div class="col" (click)="deleteSubscriber()">
            <button
              class="btn btn-danger btn-lg w-100"
              [disabled]="!cancelReason"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template
    let-subscriptionPlan="subscriptionPlan"
    let-allottedSlots="allottedSlots"
    #pricebreakdownTemplate
  >
    <!--price breakdown template-->
    <div class="p-2 ps-0 mt-2">
      <!-- Headers -->
      <div class="row row-cols-4 mb-3">
        <div class="col-4"></div>
        <div class="col-2 fw-bold text-center">Qty</div>
        <div class="col-3 fw-bold text-end">Unit Price</div>
        <div class="col-3 fw-bold text-end">Sub Total</div>
      </div>

      <!-- Base Plan -->
      <div class="row row-cols-4 mb-3">
        <div class="col-4">
          {{ subscriptionPlan?.plan?.name }}
          <div class="small">
            Includes {{ subscriptionPlan?.plan?.allowed_users }} Users
          </div>
        </div>
        <div class="col-2 text-center">1</div>
        <div class="col-3 text-end">
          {{ regionCurrencySymbol
          }}{{ (subscriptionPlan?.plan?.final_amount).toFixed(2) }}
        </div>
        <div class="col-3 text-end">
          {{ regionCurrencySymbol
          }}{{ (subscriptionPlan?.plan?.final_amount).toFixed(2) }}
        </div>
      </div>

      <!-- Additional Guards -->
      @if (allottedSlots - subscriptionPlan?.plan?.allowed_users > 0) {
        <div class="row row-cols-4 mb-3">
          <div class="col-4">Additional User(s)</div>
          <div class="col-2 text-center">
            {{ allottedSlots - subscriptionPlan?.plan?.allowed_users }}
          </div>
          <div class="col-3 text-end">
            {{ regionCurrencySymbol
            }}{{ subscriptionPlan?.plan?.user_cost?.toFixed(2) }}
          </div>
          <div class="col-3 text-end">
            {{ regionCurrencySymbol
            }}{{
              (
                subscriptionPlan?.plan?.user_cost *
                (allottedSlots - subscriptionPlan?.plan?.allowed_users)
              ).toFixed(2)
            }}
          </div>
        </div>
      }
      <!-- reserved user billing info-->
      @if (reservedUserBillingInfo) {
        <div class="row row-cols-4 mb-3">
          <div
            class="col-4 fw-semibold"
            role="button"
            (click)="openReserveUserBillingTemplate()"
          >
            Casual User Fees
            <span><i class="fa-solid fa-circle-info fs-6"></i></span>
          </div>
          <div class="col-2 text-center">
            {{ reservedUserBillingInfo?.total_count }}
          </div>
          <div class="col-3 text-end">
            {{ regionCurrencySymbol
            }}{{ reservedUserBillingInfo?.per_day_per_guard_price?.toFixed(2) }}
          </div>
          <div class="col-3 text-end">
            {{ regionCurrencySymbol
            }}{{ (reservedUserBillingInfo?.total_amount).toFixed(2) }}
          </div>
        </div>
      }

      <!-- Discount if any-->
      @if (subscriptionPlan?.app_coupon?.discount > 0) {
        <div class="row row-cols-4 mb-3">
          <div class="col-4">Discount</div>
          <div class="col-2 text-center"></div>
          <div class="col-3 text-end"></div>
          <div class="col-3 text-end">
            - {{ regionCurrencySymbol
            }}{{ (subscriptionPlan?.app_coupon?.discount).toFixed(2) }}
          </div>
        </div>
      }

      <!-- <div class="fw-bold mt-2 text-end">
        {{
          subscriptionPlan?.plan?.allowed_users > allottedSlots
            ? subscriptionPlan?.plan?.allowed_users
            : allottedSlots
        }}
        Users Total
      </div> -->

      <div class="fw-bold mt-2 text-end">
        {{ regionCurrencySymbol
        }}{{
          (
            subscriptionPlan
            | misc
              : "getFinalPaymentAmount"
              : totalPermanentUsers
              : reservedUserBillingInfo
          ).toFixed(2)
        }}
        Total
      </div>
    </div>
  </ng-template>
</div>
